import React, { memo, forwardRef } from "react";
const SvgNumbertwo = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M11.3 11.1a4.526 4.526 0 011.72-1.86c.76-.48 1.64-.72 2.64-.72.613 0 1.2.087 1.76.26.573.173 1.08.44 1.52.8.44.347.787.78 1.04 1.3.267.507.4 1.1.4 1.78 0 .453-.06.88-.18 1.28a4.81 4.81 0 01-.5 1.1 6.3 6.3 0 01-.72 1c-.267.307-.56.607-.88.9l-4.08 3.9h5.34c.253 0 .46.04.62.12.16.08.287.18.38.3a.768.768 0 01.18.36c.027.12.04.227.04.32s-.013.207-.04.34a.913.913 0 01-.18.36c-.093.107-.22.2-.38.28-.16.08-.367.12-.62.12h-6.94c-.36 0-.647-.04-.86-.12a1.434 1.434 0 01-.5-.34 1.16 1.16 0 01-.22-.42 2.175 2.175 0 01-.04-.38c0-.213.047-.433.14-.66.107-.227.333-.507.68-.84l4.82-4.8c.44-.427.787-.853 1.04-1.28.267-.44.4-.94.4-1.5 0-.667-.22-1.193-.66-1.58-.427-.4-.96-.6-1.6-.6-.987 0-1.713.513-2.18 1.54-.133.28-.307.5-.52.66-.2.16-.427.24-.68.24-.32 0-.593-.1-.82-.3-.213-.213-.32-.487-.32-.82 0-.133.02-.26.06-.38.04-.133.087-.253.14-.36z"
      />
    </svg>
  );
});
SvgNumbertwo.displayName = "SvgNumbertwo";
const MemoForwardRef = memo(SvgNumbertwo);
export default MemoForwardRef;
